import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Invitation } from "@models/invitation";
import { Page } from "@models/page";
import { hasInputChanged } from "@shared/helpers/hasChanges/hasChanges.helper";
import { PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { EventInvitationCardComponent } from "./event-invitation-card/event-invitation-card.component";

@Component({
    selector: "app-events-invitations-list",
    imports: [SkeletonModule, ButtonComponent, EventInvitationCardComponent],
    templateUrl: "./events-invitations-list.component.html",
    styleUrl: "./events-invitations-list.component.scss"
})
export class EventsInvitationsListComponent implements OnChanges {
  @Input() invitationsPage: Page<Invitation> | null = null;
  @Input() isLoading = false;

  @Output() acceptInvitationClick = new EventEmitter<number>();
  @Output() declineInvitationClick = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<PaginatorState>();

  invitations: Invitation[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    const hasChanges = hasInputChanged<
      EventsInvitationsListComponent,
      "invitationsPage"
    >(changes, "invitationsPage");
    if (hasChanges) {
      console.log("hasChanges", hasChanges);
      const invitationChanges: SimpleChanges["invitationsPage"] =
        changes["invitationsPage"];

      const newPage = invitationChanges.currentValue?.meta.page;
      const oldPage = invitationChanges.previousValue?.meta.page;

      if (invitationChanges && invitationChanges.currentValue?.data) {
        if (oldPage != null && newPage! > oldPage) {
          this.invitations.push(...invitationChanges.currentValue.data);
        } else {
          this.invitations = [...invitationChanges.currentValue.data];
        }
      }
    }
  }

  loadMoreInvitations() {
    const paginationMeta = this.invitationsPage?.meta;

    if (paginationMeta) {
      const paginatorState: PaginatorState = {
        page: paginationMeta.current_page,
        pageCount: 10,
      };
      this.pageChange.emit(paginatorState);
    }
  }

  handleAcceptClick(eventId: number) {
    this.acceptInvitationClick.emit(eventId);
  }

  handleDeclineClick(eventId: number) {
    this.declineInvitationClick.emit(eventId);
  }
}
